import React from 'react'
import { updateProjectunit } from '../../store/actions/index';
import ProjectunitModal from './ProjectunitModal';
import { useTranslation } from 'react-i18next';

const EditProjectunitModal = (props) => {

  const { t } = useTranslation();
  const onSubmitAction = (values) => {
    values['id'] = props.formObject.id;
    values['project_id'] = props.formObject.project_id;
    return updateProjectunit(values);
  };

  const initialValues = { title: props.formObject.title,
      description: props.formObject.description
    };

  return (
    <ProjectunitModal
      modalTitle={ t( 'modal.edit_projectunit.title' ) }
      onSubmitAction={onSubmitAction}
      initialValues={initialValues}
    />
  )
}

export default EditProjectunitModal



// WEBPACK FOOTER //
// ./src/components/Modals/EditProjectunitModal.js